import React from "react";
import { ChangeEvent } from "react";
import { Link } from "react-router-dom";

import { V2 } from "../../Api";
import withTitle from "../withTitle";

import ViewToolbar from "../ViewToolbar";

import "../../icomoon.css";
import "../../list.css";
import "../../table.css";
import "../viewer.css";

interface IAppointmentTypesAdminViewState {
    isLoading: boolean;
    error?: string;
    types: any[];
    filteredTypes: any[];
    searchText: string;
}

class AppointmentTypesAdminView extends React.Component<{}, IAppointmentTypesAdminViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            types: [],
            isLoading: false,

            filteredTypes: [],
            searchText: ""
        }

        this.changeSearchChange = this.changeSearchChange.bind(this);
    }

    public async componentDidMount() {
        try {
            this.setState({
                error: undefined,
                isLoading: true
            });
            const types = await V2.get<any[]>("appointments/types");

            this.setState({
                types,
                filteredTypes: types,
                isLoading: false,
            });
        }
        catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <Link to="/appointments/admin/add" className="icon-plus" />
                </ViewToolbar>
                <div className="filter-control-box">
                    <input type="search" className="fill-space" placeholder="Search..." value={this.state.searchText} onChange={this.changeSearchChange} />
                </div>

                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Appointment Types</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading
                                ? <tr>
                                    <td colSpan={10}>
                                        <div className="spinner-center lds-dual-ring" />
                                    </td>
                                </tr>
                                : this.state.filteredTypes.map(a => (
                                    <tr key={a.id}>
                                        <td>{a.name}<small className="text-light"><br />{a.isWellKnown && !a.description ? "Built-in type" : a.description}</small></td>
                                        <td>
                                            <Link to={`/appointments/admin/${a.id}`} className="button small text-with-icon">
                                                {a.isWellKnown
                                                    ? <span>View</span>
                                                    : <span>Edit</span>}
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    private changeSearchChange(e: ChangeEvent<HTMLInputElement>) {
        const searchValue = e.currentTarget.value.toLowerCase();
        this.setState(s => {
            return {
                searchText: searchValue,

                filteredTypes: searchValue ? s.types.filter(g =>
                    g.name.toLowerCase().includes(searchValue) ||
                    (g.description && g.description.toLowerCase().includes(searchValue))
                ) : s.types
            }
        });
    }
}

export default withTitle("Office Appointment Types", AppointmentTypesAdminView);
